
import React, { useState, useEffect } from 'react';
import Rodape from '../../components/Rodape';
import Navegador from '../../components/NavBar';
import Cookies from 'js-cookie';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import './styles.scss';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import logo from '../../assets/imgs/logo_kapplan_energy.png';



const useStyles = makeStyles((theme) => ({
    root: {
        height: '50vh',
    },

    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    papermobile: {
        margin: theme.spacing(1, 1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    avatarmobile: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    entrada: {
        fontSize: 22
    },
}));

export default function NovaPlataforma() {

    const classes = useStyles();
    const [username, setUsername] = useState('');
    const [senha, setSenha] = useState('');
    const [erroSenha, setErroSenha] = useState(false);
    const [textoErroSenha, setTextoErroSenha] = useState('');


    const [width, setWidth] = useState(0);

    const [larguraOriginal, setLarguraOriginal] = useState(0);

    const [limiar, setLimiar] = useState(900);
    const [urlDestinoValido, setUrlDestinoValido] = useState('');



    function checkDimenssoes() {
        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;
        console.log("altura: " + altura);
        console.log("largura: " + largura);

        setLarguraOriginal(largura);
        setWidth(largura * 0.7);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });


    useEffect(() => {



        checkDimenssoes();



    }, []);


    const history = useHistory();

    const [rota, setRota] = useState(null);

    useEffect(() => {
        const r = Cookies.get("rota_nova_plataforma");
        if (r) {
            setRota(r);
        }
    }, []);

    const destino = rota
        ? `https://plataformagruporosinetos.com${rota}`
        : "https://plataformagruporosinetos.com/";

    return (
        <div style={{ padding: 40, textAlign: "center", fontFamily: "Arial" }}>
            <h1>🚀 Nova Plataforma Disponível!</h1>

            <p style={{ fontSize: 20 }}>
                Caro usuário, agora estamos no novo domínio:<br />
                <strong>plataformagruporosinetos.com</strong>
            </p>

            <p style={{ marginTop: 20, fontSize: 18 }}>
                {rota
                    ? <>Você tentou acessar: <strong>{rota}</strong></>
                    : <>Você entrou diretamente na página de migração.</>}
            </p>

            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    // opcional: limpar cookie antes de sair
                    Cookies.remove("rota_nova_plataforma", { path: "/" });
                    window.location.href = destino;
                }}
                style={{ marginTop: 20, fontSize: 18 }}
            >
                Ir para nova plataforma
            </Button>
        </div>
    );
}
